import React, { useContext } from 'react';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Button } from 'semantic-ui-react';
import { Form } from 'components/form-elements/Form';
import { Text } from 'components/typography';
import { FormattedMessage } from 'react-intl';
import { Grid } from 'components/layout/Grid';
import { MultiSelect } from 'components/form-elements/selects/MultiSelect';
import { useGetUserIn2n } from 'services/2n/get-user';
import { useUpdateUserIn2n } from 'services/2n/update-user';
import { Brikk } from 'components/Brikk';
import manageServiceSchema from 'utils/validation/schemas/manageServiceSchema';
import styles from '../../styles.module.scss';
import { UserAdministrationModalContext } from '../../UserAdministrationModalContext';
import { FetchActivationCode } from './components/FetchActivationCode';
import { RfidTags } from './components/RfidTags';
import { IntercomNumbers } from './components/IntercomNumbers';
import { mapDataForClient } from './mapData';

export const ManageService = () => {
  const { selectedUser, service, setService } = useContext(UserAdministrationModalContext);
  const userIn2n = useGetUserIn2n(selectedUser?.email);
  const updateUserIn2n = useUpdateUserIn2n(userIn2n?.user, selectedUser);

  const { assignedGroups, availableGroups, phoneNumbers, rfIdTagOne, rfIdTagTwo } = mapDataForClient(userIn2n.user);
  const isValidGroup = (group) => group?.value && group?.label;
  const allGroups = [
    ...(assignedGroups || []),
    ...(availableGroups || []),
  ].filter(isValidGroup);

  const formMethods = useForm({
    mode: 'onSubmit',
    resolver: yupResolver(manageServiceSchema),
    defaultValues: {
      groupsAndPermissions: assignedGroups,
      rfIdTagOne,
      rfIdTagTwo,
      phoneNumbers,
    },
  });

  const onSubmit = (data) => {

    const phoneNumbers = (data.phoneNumbers || []).map((item) => (item && item.Number ? String(item.Number).trim() : null)).filter(Boolean);
    const payload = {
      ...data,
      phoneNumbers,
    };
    updateUserIn2n.mutateAsync(payload, {
      onSuccess: () => {
        formMethods.reset(data);
      },
    });
  };

  const isDisabled = !formMethods.formState.isDirty || updateUserIn2n.isLoading || userIn2n.isLoading;

  return service ? (
    <div className={styles.container}>
      <Brikk.Heading
        heading="userAdminConfigureService"
      />
      <Text
        element="h2"
        bold
        xl
        size={20}
      >
        <FormattedMessage id="serviceConfiguration" />
      </Text>
      <Text
        size={20}
      >
        {service} / {selectedUser?.email}
      </Text>
    
      <FormProvider
        {...formMethods}
      >
        <Form
          id="manage-service-form"
          className={styles.formContainerSmall}
          onSubmit={formMethods.handleSubmit(onSubmit)}
        >

          <div className={styles.formWrapper}>
            <Grid
              noPadding
              oneColumn
            >
              <div className={styles.form}>

                <RfidTags />

                <IntercomNumbers />

                <FetchActivationCode />

                {/*{licensePlates.map((field, index) => (*/}
                {/*  <div*/}
                {/*    key={field.id}*/}
                {/*  >*/}
                {/*    <LabeledElement*/}
                {/*      label={index === 0 ? 'License plates' : ''}*/}
                {/*      description={index === 0 ? 'Add one or more license plates for this user' : ''}*/}
                {/*      descriptionPosition="top"*/}
                {/*    >*/}
                {/*      <div*/}
                {/*        className={styles.dynamicInputList}*/}
                {/*      >*/}
                {/*        <Input*/}
                {/*          placeholder={index === 0 ? 'ABC 123' : ''}*/}
                {/*          id={`licensePlates-${index}`}*/}
                {/*          type="text"*/}
                {/*        />*/}
                {/*        {licensePlates.length > 1 && (*/}
                {/*        <DiscardIcon*/}
                {/*          size={25}*/}
                {/*          onClick={() => removeLicensePlate(index)}*/}
                {/*        />*/}
                {/*        )}*/}
                {/*      </div>*/}
                {/*    </LabeledElement>*/}
                {/*  </div>*/}
                {/*))}*/}

                {/*<Button*/}
                {/*  onClick={() => appendLicensePlate({ name: '' })}*/}
                {/*  className={styles.button}*/}
                {/*>*/}
                {/*  <Text>*/}
                {/*    Add another*/}
                {/*  </Text>*/}
                {/*  <Icon*/}
                {/*    name="plus circle"*/}
                {/*  />*/}
                {/*</Button>*/}

                <Controller
                  name="groupsAndPermissions"
                  control={formMethods.control}
                  render={({ field }) => (
                    <MultiSelect
                      options={allGroups}
                      title="groupsAndPermissions"
                      value={field.value}
                      onChange={field.onChange}
                    />
                  )}
                />

                {/* (Intercom numbers are rendered above via IntercomNumber component) */}

              </div>
            </Grid>
          </div>

          {/*<ManageAccessToAdditionalServices />*/}

          <div className={styles.formButtons}>
            <Button
              basic
              name="cancel-service-details"
              size="small"
              intl="cancel"
              type="button"
              onClick={() => {
                setService(null);
              }}
            >
              <FormattedMessage id="cancel" />
            </Button>
            <Button
              type="submit"
              name="save-changes"
              disabled={isDisabled}
              loading={updateUserIn2n.isLoading}
            >
              <FormattedMessage id="saveChanges" />
            </Button>
          </div>
        </Form>
      </FormProvider>
    </div>
  ) : null;
};
